const searchFields = [
    { name: "PROFILECODE", type: "text", label: "Profile" },
    { name: "USERDEFINEDCODE_1", type: "select",showClearButton:true, label: "Code 1" },
    { name: "CREATIONUSERID", type: "text", label: "Creation By" },
    { name: "ALLOWDUPLICATEPO", type: "select",showClearButton:true, label: "PO/Reference" },
    { name: "SUBLOT_ALTERNATEIDMETHOD", type: "select",showClearButton:true, label: "Alternate ID" },
    { name: "CREATIONUSERID", type: "text", label: "Created By" },
    { name: "DESCRIPTION", type: "text", label: "Description" },
    { name: "USERDEFINEDCODE_2", type: "select",showClearButton:true, label: "Code 2" },
    { name: "LASTUPDATEUSERID", type: "text", label: "Last Update By" },
    { name: "DUPLICATESUBLOT", type: "select",showClearButton:true, label: "Sublot" },
    { name: "TRANSACTIONPREFIX", type: "text", label: "Prefix" },
    { name: "LASTUPDATEDATETIME", type: "datetime", label: "Last Updated" },
    { name: "USERDEFINEDCODE_3", type: "select",showClearButton:true, label: "Code 3" },
    { name: "USERDEFINEDCODE_4", type: "select",showClearButton:true, label: "Code 4" },
    { name: "USECRATE", type: "select",showClearButton:true, label: "Use Crate" },
    { name: "WORKUNITUOM", type: "text", label: "Work Unit UOM" },
    { name: "LASTUPDATEUSERID", type: "text", label: "Last Updated By" },
    { name: "USERDEFINEDCODE_5", type: "select",showClearButton:true, label: "Code 5" },
    { name: "SHIPMENTSONNEG_AVL", type: "select",showClearButton:true, label: "Allow(-)-Avi" },
    { name: "OPENITEMREFERENCE", type: "text", label: "Open Item Reference" },
    { name: "KEYSEQUENCE", type: "text", label: "Record#" },
    { name: "CREATIONDATETIME", type: "datetime", label: "Creation Date" },
    { name: "COMMITDATEOPTION", type: "text", label: "Commit Date Option" },
    { name: 'COMMENT', type: 'text', label: 'Comment' },
    { name: "populatelotwithcarrier", type: 'text', label: "Carrier Info" },
    { name: "shippernogeneration", type: 'text', label: "Shipper Generation" },
    { name: "printsscclabel", type: 'text', label: "Print SSCC Label" },
    { name: "printserialnumberlabel", type: 'text', label: "Print Serial# Label" },
    { name: "printpickingslipsequence", type: 'text', label: "Print Picking Slip Sequence" },
    { name: "datevalidation", type: 'text', label: "Date Validation" },
    { name: "showserialnopopup", type: 'select',showClearButton:true, label: "Show Serial# Popup" },
    { name: "useonessccpertrans", type: 'select',showClearButton:true, label: "Use 1 SSCC" },
    { name: "uservalidationoncommit", type: 'select',showClearButton:true, label: "User Validation Commit" },
    { name: "isplaceholderrecord", type: 'select',showClearButton:true, label: "Placeholder" },
    { name: "arcommitmethod", type: 'text', label: "Commit Basis" },
    { name: "rftransaction", type: 'select',showClearButton:true, label: "RFTRANSACTION" },
    { name: "rfgrouP_FULLQTY", type: 'text', label: "RF/Group When Full Qty" },
    { name: "rfgrouP_PARTIALQTY", type: 'text', label: "RF/Group When Partial Qty" },
    { name: "openitemreference", type: 'text', label: "Reference#" },
    { name: "popupmessageuser", type: 'text', label: "User Message" },
    { name: "autogenerateserialnumber", type: 'text', label: "Auto Generate Serial#" },
    { name: "validateactrecshipdt", type: 'select',showClearButton:true, label: "Validate" },
    { name: "allowblanklocations", type: 'text', label: "Blank Location" },
    { name: "locationmethoD_RECEIPTS", type: 'text', label: "Location" },
    { name: "plandatetimedefault", type: 'text', label: "Plan Appt Date Time" },
    { name: "navreporT1FORMAT", type: 'text', label: "Rpt1 Format" },
    { name: "navreporT1NAME", type: 'text', label: "Rpt1 Name" },
    { name: "navreporT1STATUS", type: 'select',showClearButton:true, label: "Rpt1 Status" },
    { name: "navreporT1TEXT", type: 'text', label: "Rpt1 Text" },
    { name: "navreporT1TYPE", type: 'select',showClearButton:true, label: "Rpt1 Type" },
    { name: "navreporT2STATUS", type: 'select',showClearButton:true, label: "Rpt2 Status" },
    { name: "navreporT2TEXT", type: 'text', label: "Rpt2 Text" },
    { name: "navreporT2TYPE", type: 'select',showClearButton:true, label: "Rpt2 Type" },
    { name: "shipmentqtychkondtlsave", type: 'select',showClearButton:true, label: "Ordered <> Act" },
    { name: "navreporT2NAME", type: 'text', label: "Rpt2 Name" },
    { name: "popupmessageuser", type: 'text', label: "User Msg" },
    { name: "ignoresamedayshiptime", type: 'text', label: "Ignore Time" },
    { name: "populateactualrsdate", type: 'text', label: "Rec/Ship Dt" },
    { name: "processdynevalcharges", type: 'text', label: "Dyn Chrgs" },
    { name: "sublotverification", type: 'text', label: "Sublot Verify" },
    { name: "receiptcommitorderedactual", type: 'text', label: "Receipt Qty" },
    { name: "otcreateitemflag", type: 'text', label: "Create Items" },
    { name: "transfertocompanyid", type: 'text', label: "To Company Id" },
    { name: "navreporT2FORMAT", type: 'text', label: "Rpt2 Format" },
    { name: "navreporT3STATUS", type: 'select',showClearButton:true, label: "Rpt3 Status" },
    { name: "ownrtransfrcrtchrgs", type: 'select',showClearButton:true, label: "Item Charges" },
    { name: "navreporT3TEXT", type: 'text', label: "Rpt3 Text" },
    { name: "navreporT3TYPE", type: 'select',showClearButton:true, label: "Rpt3 Type" },
    { name: "navreporT3NAME", type: 'text', label: "Rpt3 Name" },
    { name: "navreporT3FORMAT", type: 'text', label: "Rpt3 Format" },
    { name: "navreporT4STATUS", type: 'select',showClearButton:true, label: "Rpt4 Status" },
    { name: "navreporT4TEXT", type: 'text', label: "Rpt4 Text" },
    { name: "navreporT4TYPE", type: 'select',showClearButton:true, label: "Rpt4 Type" },
    { name: "navreporT4NAME", type: 'text', label: "Rpt4 Name" },
    { name: "status", type: 'text', label: "Status" },
    { name: "navreporT4FORMAT", type: 'text', label: "Rpt4 Format" },
    { name: "esitmatedweight", type: 'select',showClearButton:true, label: "Estimated Wt" },
    { name: "actrecshipdtdaysahead", type: 'text', label: "Days Ahead" },
    { name: "actrecshipdtdaysbehind", type: 'text', label: "Days Behind" },
    { name: "lotexpirationdatecheck", type: 'text', label: "Lot Expiration Date Check" },
    { name: "generateinspection", type: 'text', label: "Inspection" },
    { name: "reasonmandatory", type: 'text', label: "Reason Mandatory" },
    { name: "lotstoragedate", type: 'select',showClearButton:true, label: "Storage Date" },
    { name: "splitordersourcefield", type: 'select',showClearButton:true, label: "Split Order Source" },
    { name: "creditcheckonstagechange", type: 'text', label: "On Stage" },
    { name: "splitorder", type: 'select',showClearButton:true, label: "Split Receipt" },
    { name: "stagingdatetimedefault", type: 'select',showClearButton:true, label: "Staging D/T" },
    { name: "printserialnomanifestrev", type: 'text', label: "Print Serial# Manifest-Revised" },
    { name: "printreceiptconfirmation", type: 'text', label: "Print Receipt Confirmation" },
    { name: "oversellingwarning", type: 'text', label: "Over Selling" },
    { name: "screentotals", type: 'select',showClearButton:true, label: "Screen Totals" },
    { name: "detailudfields", type: 'select',showClearButton:true, label: "UD Feilds" },
    { name: "updateudfields", type: 'select',showClearButton:true, label: "Update Info" },
    { name: "shipmentsonneT_AVL", type: 'select',showClearButton:true, label: "Ordered > Net Avail" },
    { name: "showshipperonreceipt", type: 'select',showClearButton:true, label: "Show Shipper" },

    

];
const GROUP_COUNT = 4;
const TransactionProfileSearchLayout = Array.from({ length: GROUP_COUNT }, (_, i) => ({
    groupId: i + 1,
    label: "",
    fields: []
}));
searchFields.forEach((field, index) => {
    const groupIndex = index % GROUP_COUNT;

    TransactionProfileSearchLayout[groupIndex].fields.push({
        ...field,
        key: `${field.name}_${index}`,  
        tableName: "",
        options: field.options ?? null,
        apiUrl: field.apiUrl ?? null,
        grid: null,
        required: false,
        visible: field.visible ?? true
    });
});

export default TransactionProfileSearchLayout;